import ReactFullpage from '@fullpage/react-fullpage'

import {
  BottomSilhouettes,
  Face,
  FullContainer,
} from '../../components/scrollingContainer/styled'
import { Header } from '../../components/header'
import Intro from '../../components/screens/intro'
import { texts } from '../../components/locale'
import { SilhouettesTitle } from '../../components/screens/silhouettes/title'
import { SilhouettesContent } from '../../components/screens/silhouettes/content'
import AnswerContainer from '../../components/screens/answers'
import ScreenIcons from '../../components/screens/screenIcons'
import imgUrlSilhouettes from '../../components/screens/assets/BottomSilhouettes.svg'
import AllTogether from '../../components/screens/allTogether'
import { Footer } from '../../components/footer'
import { useMedia } from '../../hooks/useMedia'
import { ScreenSize } from '../../styles/mq'

import imgUrl1 from '../../components/screens/assets/01.webp'
import imgUrl2 from '../../components/screens/assets/02.webp'
import imgUrl3 from '../../components/screens/assets/03.webp'
import imgUrl4 from '../../components/screens/assets/04.webp'

import { ParagraphContainer } from '../../components/container'
import {
  Centered,
  Columns,
  LargeText,
  Section,
  SectionWrapper,
  TallContent,
} from './styled'

export const Home = () => {
  const isLarge = useMedia(
    [`(min-width: ${ScreenSize.MD / 16}em)`],
    [true],
    false
  )

  return (
    <>
      <ReactFullpage
        credits={{ position: 'left', label: '' }}
        scrollingSpeed={1000}
        render={({ state, fullpageApi }) => {
          return (
            <ReactFullpage.Wrapper>
              <Section>
                <Header />
                <Intro />
              </Section>
              {!isLarge && (
                <Section>
                  <FullContainer className="introduction">
                    <p>{texts.description}</p>
                  </FullContainer>
                </Section>
              )}

              <Section>
                <FullContainer>
                  <SectionWrapper>
                    <Centered>
                      <SilhouettesTitle />
                    </Centered>
                    <SilhouettesContent />
                  </SectionWrapper>
                </FullContainer>
              </Section>

              <Section>
                <FullContainer>
                  <ParagraphContainer>
                    <p>{texts.screen3_1}</p>
                    <p>{texts.screen3_2}</p>
                    <p>{texts.screen3_3}</p>
                  </ParagraphContainer>
                </FullContainer>
              </Section>

              <Section>
                <FullContainer>
                  <ParagraphContainer>
                    <p>{texts.screen4_1}</p>
                    <p>{texts.screen4_2}</p>
                  </ParagraphContainer>
                </FullContainer>
              </Section>

              <Section>
                <FullContainer>
                  <LargeText>{texts.screen5}</LargeText>
                </FullContainer>
              </Section>
              <Section>
                <Centered>
                  <h2>{texts.screen6}</h2>
                </Centered>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="left" woman={1} />
                </SectionWrapper>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="right" woman={2} />
                </SectionWrapper>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="left" woman={3} />
                </SectionWrapper>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="right" woman={4} />
                </SectionWrapper>
              </Section>
              <Section>
                <Centered>
                  <h2>{texts.screen8}</h2>
                </Centered>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="right" woman={5} />
                </SectionWrapper>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="left" woman={6} />
                </SectionWrapper>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="right" woman={7} />
                </SectionWrapper>
              </Section>
              <Section data-fade-only>
                <SectionWrapper>
                  <AnswerContainer direction="left" woman={8} />
                </SectionWrapper>
              </Section>
              <Section>
                <FullContainer>
                  <Centered>
                    <h2>{texts.screen10}</h2>
                  </Centered>
                </FullContainer>
              </Section>
              <Section data-fade-only>
                <FullContainer className="long-for-mobile">
                  <Face $dir="left">
                    <img src={imgUrl2} />
                    <div>{texts.faces_1}</div>
                  </Face>
                </FullContainer>
              </Section>
              <Section data-fade-only>
                <FullContainer className="long-for-mobile">
                  <Face $dir="right">
                    <img src={imgUrl4} />
                    <div>{texts.faces_2}</div>
                  </Face>
                </FullContainer>
              </Section>
              <Section data-fade-only>
                <FullContainer className="long-for-mobile">
                  <Face $dir="left">
                    <img src={imgUrl1} />
                    <div>{texts.faces_3}</div>
                  </Face>
                </FullContainer>
              </Section>
              <Section data-fade-only>
                <FullContainer className="long-for-mobile">
                  <Face $dir="right">
                    <img src={imgUrl3} />
                    <div>{texts.faces_4}</div>
                  </Face>
                </FullContainer>
              </Section>
              <Section>
                <SectionWrapper>
                  <FullContainer>
                    <ScreenIcons />
                  </FullContainer>
                </SectionWrapper>
              </Section>
              <Section>
                <TallContent>
                  <FullContainer className="long-for-mobile">
                    <AllTogether />
                  </FullContainer>
                </TallContent>
              </Section>
              <Section>
                <SectionWrapper>
                  <FullContainer className="long-for-mobile">
                    <Columns>
                      <p>{texts.screen13_1}</p>
                      <p>{texts.screen13_2}</p>
                      <p>{texts.screen13_3}</p>
                      <p>{texts.screen13_4}</p>
                      <p>{texts.screen13_5}</p>
                      <p>{texts.screen13_6}</p>
                    </Columns>
                  </FullContainer>
                </SectionWrapper>
              </Section>
              <Section>
                <SectionWrapper>
                  <FullContainer>
                    <ParagraphContainer>
                      <p>{texts.screen14_1}</p>
                      <p>{texts.screen14_2}</p>
                      <p>{texts.screen14_3}</p>
                      <p>{texts.screen14_4}</p>
                    </ParagraphContainer>
                  </FullContainer>
                </SectionWrapper>
              </Section>
              <Section>
                <SectionWrapper>
                  <FullContainer>
                    <LargeText>
                      <p>{texts.screen15_1}</p>
                      <p>{texts.screen15_2}</p>
                    </LargeText>
                  </FullContainer>
                </SectionWrapper>
                <BottomSilhouettes>
                  <img src={imgUrlSilhouettes} />
                  <img src={imgUrlSilhouettes} />
                </BottomSilhouettes>
              </Section>
              <Section>
                <Footer />
              </Section>
            </ReactFullpage.Wrapper>
          )
        }}
      />
    </>
  )
}
